import $ from 'jquery';
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const slide = () => {
    const swiperContainer = document.querySelector('.js-slide-swiper');
    if (!swiperContainer) return;

    const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    // Swiper初期化
    const swiper = new Swiper(swiperContainer, {
        modules: [Autoplay],
        loop: true,
        speed: 10000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        freeMode: true,
        freeModeMomentum: false,
        allowTouchMove: true,

        // --- ここでブレークポイントを定義 ---
        slidesPerView: 6,
        breakpoints: {
            0: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
        },
    });

    // CSSトランジションを滑らかに
    const wrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (wrapper) {
        wrapper.style.transitionTimingFunction = 'linear';
    }
};

const main = () => {
    if (!document.querySelector('#page-company')) return;
    slide();
};

export default main;
